export const ALPHA_NUMERIC_DASH_REGEX = /^[0-9]+$/;
export const PHONE_REGEX = /^(84|0[3|5|7|8|9])+([0-9]{8})\b$/;
